import { Avatar } from "@mui/material";
import { styled } from "@mui/material/styles";

export const SmallAvatar = styled(Avatar)(() => ({
  width: "24px",
  height: "24px",
  fontSize: "16px",
}));

export const MediumAvatar = styled(Avatar)(() => ({
  width: "90px",
  height: "90px",
  fontSize: "60px",
  margin: "0 auto",
}));

export const LargeAvatar = styled(Avatar)(() => ({
  width: "120px",
  height: "120px",
  fontSize: "80px",
}));
